'use strict';

// Unescapes the slash in path parameters
intellidealerAppCoreModule.filter('pathParam', function () {
  return function(input) {
    return input.replace(/%2F/gi, '/');
  };
});